import React from 'react';
import Checkbox from '../components/Checkbox';
import './Analysis.css';

/* We accept 'isLoading' to know when to show the spinner */
const Analysis = ({ preprocessing, togglePreprocessing, handleRunAnalysis, isLoading }) => {
  return (
    <div className="analysis-container">
      <div className="analysis-widget">
        <div className="analysis-header">
          Preprocessing Options
        </div>
        <div className="analysis-content">
          <Checkbox
            checked={preprocessing.normalize}
            onChange={() => togglePreprocessing('normalize')}
            label="Normalize Data (0-1 scaling)"
          />
          <Checkbox
            checked={preprocessing.standardize}
            onChange={() => togglePreprocessing('standardize')}
            label="Standardize Data (z-score)"
          />
          <Checkbox
            checked={preprocessing.removeMissing}
            onChange={() => togglePreprocessing('removeMissing')}
            label="Remove Missing Values"
          />
          
          {/* Button Logic: If loading, disable and show spinner */}
          <button
            className="run-analysis-button"
            onClick={handleRunAnalysis}
            disabled={isLoading}
          >
            {isLoading ? (
              /* Spinner View */
              <div className="loading-content">
                <span className="spinner"></span> 
                Running Analysis...
              </div>
            ) : (
              /* Normal View */
              "Run Analysis"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Analysis;